import type {
  PlayDraftValidation,
  RunnerDestination,
} from "../shared/types/contracts";

export interface PlayResult {
  key: string;
  bases?: number;
  out?: boolean;
  error?: boolean;
}

export function expectedRunsForPlay(
  result: PlayResult,
  decisions: Record<number, RunnerDestination>,
): number {
  return (
    Object.values(decisions).filter((destination) => destination === "H")
      .length + (result.key === "HR" ? 1 : 0)
  );
}

export function batterDestination(result: PlayResult): number | null {
  return result.out || result.key === "HR" ? null : (result.bases || 1) - 1;
}

export function validatePlayDraft(
  result: PlayResult,
  decisions: Record<number, RunnerDestination>,
): PlayDraftValidation {
  const destinationCounts = new Map<number, number>();
  for (const destination of Object.values(decisions)) {
    if (typeof destination !== "number") continue;
    destinationCounts.set(
      destination,
      (destinationCounts.get(destination) ?? 0) + 1,
    );
  }

  const batterBase = batterDestination(result);
  if (batterBase !== null) {
    destinationCounts.set(
      batterBase,
      (destinationCounts.get(batterBase) ?? 0) + 1,
    );
  }

  const collisionBases = [...destinationCounts.entries()]
    .filter(([, count]) => count > 1)
    .map(([base]) => base)
    .sort((a, b) => a - b);
  const fcOuts = Object.values(decisions).filter(
    (destination) => destination === "X",
  ).length;
  const fcViolation = result.key === "FC" && fcOuts !== 1;

  return {
    valid: collisionBases.length === 0 && !fcViolation,
    collisionBases,
    expectedRuns: expectedRunsForPlay(result, decisions),
    message:
      collisionBases.length > 0
        ? "Two runners can't end up on the same base"
        : fcViolation
          ? "Pick which runner was out"
          : null,
  };
}
